import { AnimatePresence, motion } from 'framer-motion';

type BurgerIconProperties = {
  isOpen: boolean;
};

export function BurgerIcon({ isOpen }: BurgerIconProperties) {
  return (
    <AnimatePresence mode="wait">
      {isOpen ? (
        <motion.div
          key="close"
          initial={{ opacity: 0, rotate: 90, scale: 0.8 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: -90, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          className="relative flex h-6 w-7 items-center justify-center"
        >
          <motion.div
            initial={{ rotate: 45 }}
            animate={{ rotate: 45 }}
            className="absolute h-1 w-7 rounded bg-primary"
          />
          <motion.div
            initial={{ rotate: -45 }}
            animate={{ rotate: -45 }}
            className="absolute h-1 w-7 rounded bg-primary"
          />
        </motion.div>
      ) : (
        <motion.div
          key="burger"
          initial={{ opacity: 0, rotate: -25, scale: 0.8 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 25, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          className="flex w-7 flex-col items-center gap-1.5"
        >
          {[1, 2, 3].map((item) => (
            <div className="h-1 w-7 rounded-sm bg-primary" key={item} />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
